import { CoreDataSecurityMonitorsByIdName } from './name';
import { createDeleteAsyncSlice } from '@sonar-software/xuder';
import { deleteDataSecurityMonitor } from '@api/data-security';
import { removeCoreDataSecurityMonitorsAllSyncSlice } from '../all/remove';
import { removeCoreDataSecurityMonitorsByApplicationSyncSlice } from '../application/remove';
import { removeCoreDataSecurityMonitorsSyncSlice } from '../remove';

export const deleteCoreDataSecurityMonitorByIdSlice = createDeleteAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [
			removeCoreDataSecurityMonitorsByApplicationSyncSlice.syncActionCreator,
			removeCoreDataSecurityMonitorsSyncSlice.syncActionCreator,
			removeCoreDataSecurityMonitorsAllSyncSlice.syncActionCreator
		]
	},
	name: CoreDataSecurityMonitorsByIdName,
	receive: false,
	request: true,
	requestHandler: deleteDataSecurityMonitor
});
